import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Auth } from '@aws-amplify/auth';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

interface NavbarItem {
  text: string;
  link: string;
}

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  triggerMenu = false;
  isLoggedIn$ = new BehaviorSubject(false);
  links: NavbarItem[] = [];
  keyGeneratorRole = false;
  constructor(private translate: TranslateService, private router: Router) {
  }

  ngOnInit(): void {
    this.checkIsLoggedIn();
    this.updateLinks();
  }

  private checkIsLoggedIn() {
    console.log('Check if is logged in...');
    Auth.currentAuthenticatedUser()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((currentUser: any) => {
        console.log(currentUser);
        if (
          currentUser.signInUserSession?.idToken?.payload[
            'custom:roles'
          ].includes('BlueCollarRegistration_KeyGenerator')
        ) {
          this.keyGeneratorRole = true;
          this.router.navigate(['/secure/generate-key']);
        } else {
          this.router.navigate(['/secure/email-change']);
        }
        this.isLoggedIn$.next(true);
        this.updateLinks();
      })
      .catch((err: Error) => {
        console.log(
          'currentUser error',
          err.name === 'UserUnAuthenticatedException',
        );
        if (err.name === 'UserUnAuthenticatedException') {
          this.isLoggedIn$.next(false);
        } else if (err.name === 'UserAlreadyAuthenticatedException') {
          this.isLoggedIn$.next(true);
        } else {
          throw err;
        }
        this.updateLinks();
      });
  }

  private updateLinks() {
    this.links = this.getLinks();
  }

  getLinks(): NavbarItem[] {
    return this.isLoggedIn$.getValue()
      ? this.getSecureLinks()
      : this.getPublicLinks();
  }

  private getPublicLinks(): NavbarItem[] {
    return [
      {
        link: '/public/register',
        text: this.translate.instant('HEADER.REGISTER'),
      },
      {
        link: '/public/check-status',
        text: this.translate.instant('HEADER.STATUS_CHECK'),
      },
      // {
      //   link: '/public/password-reset',
      //   text: this.translate.instant('HEADER.RESET_PASSWORD'),
      // }
    ];
  }

  private getKeyGeneratorLink(): NavbarItem[] {
    return [
      {
        text: this.translate.instant('HEADER.GENERATE_KEY'),
        link: '/secure/generate-key',
      },
    ];
  }

  private getSecureLinks(): NavbarItem[] {
    if (this.keyGeneratorRole) {
      return [
        // ...this.getPublicLinks(),
        ...this.getKeyGeneratorLink(),
        // {
        //   text: this.translate.instant('HEADER.CHANGE_EMAIL'),
        //   link: '/secure/email-change',
        // },
      ];
    } else {
      return [
        // ...this.getPublicLinks(),
        {
          text: this.translate.instant('HEADER.CHANGE_EMAIL'),
          link: '/secure/email-change',
        },
      ];
    }
  }

  login() {
    console.log('Login called');
    Auth.federatedSignIn({ customProvider: 'DraexlmaierAzureAD' });
  }

  logout() {
    console.log('Logout called');
    Auth.signOut();
  }

  toggleMenu() {
    this.triggerMenu = !this.triggerMenu;
  }
}
